import styled from 'styled-components'

import { flexRow } from '~/shared/styles/layout'

export const Wrapper = styled.div`
  ${flexRow}
  justify-content: center;
  padding: 16px;
  width: 100%;
`
